// extracted by mini-css-extract-plugin
module.exports = {"votesInput":"AddEthAsset_votesInput__2-1Vk","tokenIdInput":"AddEthAsset_tokenIdInput__5BdWA"};